import { PUBNUB_COOKIE_KEY } from '../../../shared';

export const getChatCookieKey = (chatDescriptor: string) =>
  `${PUBNUB_COOKIE_KEY}_${chatDescriptor}`;
